import { Values } from '../interfaces';

export enum PaymentLinkActionType {
  INIT_PAYMENT_LINK = 'PAYMENT_LINK/INIT_PAYMENT_LINK',
  CLEAN_ERROR_PAYMENT_LINK = 'PAYMENT_LINK/CLEAN_ERROR',
  GET_CURRENCIES = 'PAYMENT_LINK/GET_CURRENCIES',
  GET_CURRENCIES_SUCCESS = 'PAYMENT_LINK/GET_CURRENCIES_SUCCESS',
  GET_CURRENCIES_ERROR = 'PAYMENT_LINK/GET_CURRENCIES_ERROR',
  GET_DOCUMENT_TYPES_FOR_PAYMENT_LINK = 'PAYMENT_LINK/GET_DOCUMENT_TYPES_FOR_PAYMENT_LINK',
  GET_DOCUMENT_TYPES_FOR_PAYMENT_LINK_SUCCESS = 'PAYMENT_LINK/GET_DOCUMENT_TYPES_FOR_PAYMENT_LINK_SUCCESS',
  GET_DOCUMENT_TYPES_FOR_PAYMENT_LINK_ERROR = 'PAYMENT_LINK/GET_DOCUMENT_TYPES_FOR_PAYMENT_LINK_ERROR',
  PAYMENT_LINK_RESULT = 'PAYMENT_LINK/PAYMENT_LINK_RESULT',
  CREATE_PAYMENT_LINK = 'PAYMENT_LINK/CREATE_PAYMENT_LINK',
  CREATE_PAYMENT_LINK_ERROR = 'PAYMENT_LINK/CREATE_PAYMENT_LINK_ERROR',
  CREATE_PAYMENT_LINK_SUCCESS = 'PAYMENT_LINK/CREATE_PAYMENT_LINK_SUCCESS',
  GET_EXISTING_CLIENTS = 'PAYMENT_LINK/GET_EXISTING_CLIENTS',
  GET_EXISTING_CLIENTS_SUCCESS = 'PAYMENT_LINK/GET_EXISTING_CLIENTS_SUCCESS',
  GET_EXISTING_CLIENTS_ERROR = 'PAYMENT_LINK/GET_EXISTING_CLIENTS_ERROR',
  GET_CREATED_PAYMENT_LINKS = 'PAYMENT_LINK/GET_CREATED_PAYMENT_LINKS',
  GET_CREATED_PAYMENT_LINKS_SUCCESS = 'PAYMENT_LINK/GET_CREATED_PAYMENT_LINKS_SUCCESS',
  GET_CREATED_PAYMENT_LINKS_ERROR = 'PAYMENT_LINK/GET_CREATED_PAYMENT_LINKS_ERROR',
}

export const initPaymentLink = () => ({
  type: PaymentLinkActionType.INIT_PAYMENT_LINK,
});

export const cleanErrorPaymentLink = () => ({
  type: PaymentLinkActionType.CLEAN_ERROR_PAYMENT_LINK,
});

export const getCurrencies = (country: string) => ({
  type: PaymentLinkActionType.GET_CURRENCIES,
  country,
});

export const getCurrenciesSuccess = (response: any) => ({
  type: PaymentLinkActionType.GET_CURRENCIES_SUCCESS,
  response,
});

export const getCurrenciesError = (error: any) => ({
  type: PaymentLinkActionType.GET_CURRENCIES_ERROR,
  error,
});

export const getDocumentTypesForPaymentLink = (country: string) => ({
  type: PaymentLinkActionType.GET_DOCUMENT_TYPES_FOR_PAYMENT_LINK,
  country,
});

export const getDocumentTypesForPaymentLinkSuccess = (response: any) => ({
  type: PaymentLinkActionType.GET_DOCUMENT_TYPES_FOR_PAYMENT_LINK_SUCCESS,
  response,
});

export const getDocumentTypesForPaymentLinkError = (error: any) => ({
  type: PaymentLinkActionType.GET_DOCUMENT_TYPES_FOR_PAYMENT_LINK_ERROR,
  error,
});

export const paymentLinkResult = (show: boolean) => ({
  type: PaymentLinkActionType.PAYMENT_LINK_RESULT,
  show,
});

export const postCreatePaymentLink = (values: Values) => ({
  type: PaymentLinkActionType.CREATE_PAYMENT_LINK,
  values,
});

export const postCreatePaymentLinkSuccess = (response: any) => ({
  type: PaymentLinkActionType.CREATE_PAYMENT_LINK_SUCCESS,
  response,
});

export const postCreatePaymentLinkError = (error: any) => ({
  type: PaymentLinkActionType.CREATE_PAYMENT_LINK_ERROR,
  error,
});

export const getExistingClients = (page: number, country: string) => ({
  type: PaymentLinkActionType.GET_EXISTING_CLIENTS,
  page,
  country,
});

export const getExistingClientsSuccess = (response: any) => ({
  type: PaymentLinkActionType.GET_EXISTING_CLIENTS_SUCCESS,
  response,
});

export const getExistingClientsError = (error: any) => ({
  type: PaymentLinkActionType.GET_EXISTING_CLIENTS_ERROR,
  error,
});

export const getCreatedPaymentLinks = (page?: number, rowsPerPage?: number) => ({
  type: PaymentLinkActionType.GET_CREATED_PAYMENT_LINKS,
  page,
  rowsPerPage,
});

export const getCreatedPaymentLinksSuccess = (response: any) => ({
  type: PaymentLinkActionType.GET_CREATED_PAYMENT_LINKS_SUCCESS,
  response,
});

export const getCreatedPaymentLinksError = (error: any) => ({
  type: PaymentLinkActionType.GET_CREATED_PAYMENT_LINKS_ERROR,
  error,
});
